import { SearchProviderActionConstants, SearchProviderReduxAction } from 'actions/searchProvider'
import { SearchProviderRedux } from 'types/SearchProvider'

export const defaultState = {
  // list of artworks returned by generic search provider following the typing of SAArtwork
  results: [],
  // List of facets returned by generic search provider follwoing the typing of SAFacets
  facets: {},
  // All Facets selected got from URL
  selectedFacets: {},
  // Index used by generic search provider to know which database to consult
  searchIndice: '',
  // Pagination values to control UI of pagination component
  pagination: {
    resultsPerPage: 0,
    pageNumber: 0,
    totalResults: 0,
  },
  sort: {
    sortBy: '',
    sortOrder: '',
  },
  // Going to be used to know from the URL what are the path params selected
  sharedFacetNames: {},
  // It is going to be used to map the values from the URL to the Facets
  slugifyDictionary: {},
  isPrintsPage: false,
}

const SearchProviderReducer = (
  state: SearchProviderRedux = defaultState,
  action: SearchProviderReduxAction
) => {
  switch (action.type) {
    case SearchProviderActionConstants.UPDATE_SEARCH_PROVIDER:
      return { ...state, ...action.payload }

    default:
      return state
  }
}

export default SearchProviderReducer
